const isProduction = process.env.NODE_ENV === 'production';

export const CLASSMATE_NORMAL = 0;
export const CLASSMATE_SHRINK = 1;


export const AVATAR_NORMAL = 0;
export const AVATAR_SAYING = 1;
export const AVATAR_DISABLE = 2;


export const SELF = 0;
export const OTHER = 1;
export const TEACHER = 2;


export const SEND_TYPE_CHAT = 'CHAT';
export const SEND_TYPE_ALL = 'ALL';

export const SEND_SELF = 'to';

export const URL_SEND_EMOJ = '/panda/chat/chatmessage';
export const URL_SEND_BAN = '/panda/chat/users/band';
export const URL_SEND_LOGIN = '/panda/chat/user/login';


export const SHOW_EMOj = 'emoj';
export const SHOW_CLASS_EMOJ = 'class_emoj';


export const CLASS_EMOJ_BORED = 'batter_4';
export const SEND_OTHER = 'other';

export const CLASS_EMOJ_SMILE = 'last';
export const CLASS_EMOJ_LIGHT = 'collect';
export const CLASS_EMOJ_SLEEP = 'waiting';
export const CLASS_EMOJ_SERIOUS = 'learning_2_minutes';
// isProduction ? 'https://chat.pandateacher.com' :
export const HOST = 'https://chat.pandateacher.com';
// isProduction ? 'https://chat.pandateacher.com' :
export const SOCKET_URL = 'https://chat.pandateacher.com';





// WEBPACK FOOTER //
// ./src/modules/min-lesson/model/classmates/constant.js